import React from 'react'
import PropTypes from 'prop-types'
import OlMap from 'ol/Map'

import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'

import { builGroupdDeliverablesFromProps } from '../../groupDeliverablesUtils'
import LayerGroupContainer from '../../containers/olContainers/LayerGroupContainer'
import { isEqual } from 'lodash'
import { isHemavErrorWithCode, ERROR_CODES } from '../../helpers/errors/errorHelper'

const initialState = {
  layerGroupsData: []
}

export default class GroupDeliverablesLayer extends React.Component {
  state = initialState

  getChildContext() {
    return { map: this.context.map }
  }

  _resetState() {
    this.setState(initialState)
  }

  _prepareDeliverables(props) {
    const deliverablesGroup = builGroupdDeliverablesFromProps(props)
    const failedFieldsDeliverables = {}

    const successDeliverables = deliverablesGroup.map(deliverable => {
      const successDeliverable = deliverable.reduce((acc, d) => {
        if (!d?.error) {
          return [...acc, d]
        }
        if (isHemavErrorWithCode(d.error, ERROR_CODES.GEOMETRY_TOO_COMPLEX_TO_PROCESS)) {
          failedFieldsDeliverables[d.error?.metadata?.fieldId] = d
        }
        return acc
      }, [])

      return successDeliverable
    })

    this.setState({ layerGroupsData: successDeliverables })

    const failedFielIds = Object.keys(failedFieldsDeliverables)
    if (failedFielIds.length > 0) {
      this.props.errorNotificationWithComplexGeometry(failedFielIds)
    }
  }

  componentDidMount() {
    const { flightGroupDeliverables, flightSource } = this.props
    // fields without geometries
    if (flightSource === undefined) {
      this._resetState()
    }
    if (!isEmpty(flightGroupDeliverables)) {
      this._prepareDeliverables(this.props)
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const oldProps = this.props
    // fields without geometries
    if (nextProps.flightSource === undefined) {
      this._resetState()
    }

    if (
      !isEqual(nextProps.showLayers, oldProps.showLayers) ||
      !isEqual(nextProps.flightSource, oldProps.flightSource) ||
      !isEqual(nextProps.flightGroupDeliverables, oldProps.flightGroupDeliverables) ||
      !isEqual(nextProps.selectedFlightGroup, oldProps.selectedFlightGroup) ||
      !isEqual(nextProps.flightGroupSeasons, oldProps.flightGroupSeasons)
    ) {
      this._prepareDeliverables(nextProps)
    }
  }

  render = () => {
    const { showTemporal, showLayers, flightGroupDeliverables, orderDeliverables, temporalSwipe, groupDeliverablesBaseZIndex, token } = this.props
    const leng = showLayers ? flightGroupDeliverables.length : 0
    const temporalDisplay = showTemporal ? 'left' : 'all'

    const deliverablesLayer =
      showLayers && !isEmpty(this.state.layerGroupsData) && !isEmpty(this.state.layerGroupsData[0])
        ? this.state.layerGroupsData.map((layerGroupData, index) => {
            const deliverable = get(layerGroupData, '[0].deliverable')
            const zIndex = leng - orderDeliverables.indexOf(deliverable.id)

            if (deliverable.visible) {
              return (
                <LayerGroupContainer
                  display={temporalDisplay}
                  temporalSwipe={temporalSwipe}
                  visible={deliverable.visible}
                  opacity={deliverable.opacity}
                  zIndex={groupDeliverablesBaseZIndex + zIndex}
                  key={`maskGroup ${deliverable.id} ${index}`}
                  name="maskGroup"
                  layers={layerGroupData}
                  token={token}
                />
              )
            }
            return null
          })
        : null

    return <div>{deliverablesLayer}</div>
  }
}

GroupDeliverablesLayer.propTypes = {
  flightSource: PropTypes.number,
  deliverables: PropTypes.arrayOf(PropTypes.object),
  dispatch: PropTypes.func,
  orderDeliverables: PropTypes.arrayOf(PropTypes.number),
  showLayers: PropTypes.bool,
  showTemporal: PropTypes.bool,
  groupDeliverablesBaseZIndex: PropTypes.number,
  token: PropTypes.string
}

GroupDeliverablesLayer.contextTypes = {
  map: PropTypes.instanceOf(OlMap)
}

GroupDeliverablesLayer.childContextTypes = {
  map: PropTypes.instanceOf(OlMap)
}
